import {
  CreateVideoRenderDto,
  DeleteVideoRenderFromVimeoResponseDto,
  VideoRenderDto,
} from "@repo/api/video-render";
import { AmplifilesClient } from "./api-client";

export class VideoRenderApi {
  static async getVideoRenders(
    teamExternalId: string,
    videoExternalId: string,
  ): Promise<VideoRenderDto[]> {
    const response = await AmplifilesClient.instance.get(
      `/team/${teamExternalId}/video/${videoExternalId}/video-render`,
    );

    return VideoRenderDto.array().parse(response.data);
  }

  static async createVideoRender(
    teamExternalId: string,
    videoExternalId: string,
    data: CreateVideoRenderDto,
  ): Promise<VideoRenderDto> {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/video/${videoExternalId}/video-render`,
      data,
    );
    return VideoRenderDto.parse(response.data);
  }

  static async deleteVideoRenderFromVimeo(
    teamExternalId: string,
    videoRenderExternalId: string,
  ): Promise<DeleteVideoRenderFromVimeoResponseDto> {
    const response = await AmplifilesClient.instance.delete(
      `/team/${teamExternalId}/video-render/${videoRenderExternalId}/vimeo`,
    );
    return DeleteVideoRenderFromVimeoResponseDto.parse(response.data);
  }

  static async shareVideoRender(
    teamExternalId: string,
    videoRenderExternalId: string,
  ): Promise<VideoRenderDto> {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/video-render/${videoRenderExternalId}/share`,
    );
    return VideoRenderDto.parse(response.data);
  }

  static async deleteVideoRenderShare(
    teamExternalId: string,
    videoRenderExternalId: string,
  ): Promise<VideoRenderDto> {
    const response = await AmplifilesClient.instance.delete(
      `/team/${teamExternalId}/video-render/${videoRenderExternalId}/share`,
    );
    return VideoRenderDto.parse(response.data);
  }
}
